import { render, staticRenderFns } from "./Base.vue?vue&type=template&id=43ffd96c&"
import script from "./Base.vue?vue&type=script&lang=js&"
export * from "./Base.vue?vue&type=script&lang=js&"
import style0 from "./Base.vue?vue&type=style&index=0&id=43ffd96c&prod&lang=scss&"
import style1 from "./Base.vue?vue&type=style&index=1&id=43ffd96c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports